import {inject, Injectable, Pipe, PipeTransform} from '@angular/core';
import {TitleCasePipe as AngularTitleCasePipe} from '@angular/common';
import {isString} from '../store/common/typing.helpers';

@Injectable({providedIn: 'root'})
@Pipe({
  name: 'mxTitleCase'
})
export class TitleCasePipe implements PipeTransform {
  public transform(value: unknown): string {
    if (!isString(value)) return '';

    return this.angularTitleCasePipe.transform(value.replace(/[_-]/g, ' '));
  }

  private angularTitleCasePipe: AngularTitleCasePipe = inject(AngularTitleCasePipe);
}
